import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PolicyRoutingModule } from './policy-routing.module';
import { UnderwritingComponent } from './underwriting/underwriting.component';
import { PolicyPurchaseDetailsComponent } from './policy-purchase-details/policy-purchase-details.component';
import { MyPolicyComponent } from './my-policy/my-policy.component';
import { PolicyInfoComponent } from './policy-info/policy-info.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaymentInfoComponent } from './payment-info/payment-info.component';
import { PaymentFormComponent } from './payment-form/payment-form.component';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  declarations: [
    UnderwritingComponent,
    PolicyPurchaseDetailsComponent,
    MyPolicyComponent,
    PolicyInfoComponent,
    PaymentInfoComponent,
    PaymentFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PolicyRoutingModule,
    NgxPaginationModule,
    SharedModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatChipsModule,
    MatCheckboxModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatTableModule,
    MatDialogModule,
    MatRadioModule,
  ]
})
export class PolicyModule { }
